module.exports = __webpack_public_path__ + "media/images/logo-footer-4f5e723af76a4565ca8e57f08971e74b.png";